<div id="home">
    <!-- <app-new-showcase></app-new-showcase> -->
    <app-showcase></app-showcase>
    <!-- <app-js-showcase></app-js-showcase> -->
    <!-- <app-bulletin></app-bulletin>
<app-about></app-about> -->
    <!-- <app-why></app-why> -->

    <!-- <app-facilities></app-facilities>
<app-achievement></app-achievement> -->
    <app-menu></app-menu>
    <app-events></app-events>
    <app-blog></app-blog>
    <app-images></app-images>
    <!-- <app-testimonial></app-testimonial> -->
</div>

<div id="logo-bar">
    <a class="btn btn-lg blink" href="https://onlinefee.digitechindia.co.in/mppskurukshetra/" target="_blank">Pay
        Online</a>
</div>
<!-- <div id="logo-bar"  style="top: 82% !important;">
    <a class="btn btn-lg blink" href="https://data.odpay.in/odforms1/form/MaharanaPratapPublicSchoolRegistrationForm202223/formperma/TA3ls8GH8nYtZ2157rlON5S7PNOzk9azalrrrlK_Ytw" target="_blank">Registration Form</a>
</div>
<div id="logo-bar"  style="top: 74% !important;">
    <a class="btn btn-lg blink" href="https://data.odpay.in/odforms1/form/MaharanaPratapPublicSchoolJobApplicationForm/formperma/Ux4Lun7NE-Kn4QEQBk20oXaLg3sbYHe9V3IHdUEFD68" target="_blank">Job Application Form</a>
</div> -->


<div id="payModal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Pay Now</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <a class="btn" href="https://onlinefee.digitechindia.co.in/mppskurukshetra/" target="_blank">MPPS Sector
                    7</a>
                <a class="btn ml-3" href="https://onlinefee.digitechindia.co.in/mppscskkr/" target="_blank">MPPS City
                    Branch</a>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>


<!-- <div class="modal fade bd-example-modal-sm" id="myModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-sm modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title blink" id="exampleModalLongTitle">Welcome to MPPS</h5>
                <h5 class="modal-title blink" id="exampleModalLongTitle">Welcome to MPPS <br><span
                        style="font-size: 14px;">Online registration for LKG & UKG classes now available!</span></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                </button>
            </div>
            <div class="modal-body">
                <img class="d-block mx-auto" src="/assets/img/popup/28.jpg" alt="Notice">
                <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img class="d-block mx-auto" src="/assets/img/popup/32.jpg" alt="Notice">
                        </div>
                        <div class="carousel-item active">
                            <img class="d-block mx-auto" src="/assets/img/popup/31.jpg" alt="Notice">
                        </div>
                        <div class="carousel-item active">
                            <img class="d-block mx-auto" src="/assets/img/popup/30.jpg" alt="Notice">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block mx-auto" src="/assets/img/popup/28.jpg" alt="Notice">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block mx-auto" src="/assets/img/popup/29.jpg" alt="Notice">
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon bg-dark" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon bg-dark" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
                <div id="popupCarousel" class="carousel slide" data-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img class="d-block w-100" src="/assets/img/popup/8.jpeg" alt="Notice">
                        </div>
                        <div class="carousel-item" *ngFor="let img of popups, let i=index"
                            [ngClass]="(i == 0 ) ? 'active' : ''">
                            <img class="d-block w-100" [src]="img.imgUrl" alt="Notice">
                        </div>
                        <div class="carousel-item active">
                            <img class="d-block w-100" src="/assets/img/popup/12.jpeg" alt="Notice">
                        </div>
                        <div class="carousel-item">
                            <img class="d-block w-100" src="/assets/img/popup/11.jpeg" alt="Notice">
                        </div>
                    </div>
                    <a class="carousel-control-prev" href="#popupCarousel" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#popupCarousel" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
            </div>
            <div class="modal-footer">
                <div class="mb-3 w-100">
                    <a routerLink="/admission/entrance-result" target="_blank" class="btn mb-2 w-100">Entrance Test
                        Result</a>
                    <h4>Student Admission
                    </h4>
                    <a href="https://data.odpay.in/odforms1/form/MaharanaPratapPublicSchoolRegistrationForm202223/formperma/TA3ls8GH8nYtZ2157rlON5S7PNOzk9azalrrrlK_Ytw"
                        target="_blank" class="btn mb-2 w-100">Click here to register for class 1st</a>
                    <p style="font-size: 15px;">(Parents will be informed telephonically regarding the date and time of
                        interaction)</p>
                    <h4>Student Admission</h4>
                    <a href="https://data.odpay.in/odforms1/form/MaharanaPratapPublicSchoolRegistrationForm202223/formperma/TA3ls8GH8nYtZ2157rlON5S7PNOzk9azalrrrlK_Ytw"
                        target="_blank" class="btn mb-2 w-100">Click Here To Apply For MPPS Sector 7</a>
                    <h4>Job Application</h4>
                    <a href="https://data.odpay.in/odforms1/form/MaharanaPratapPublicSchoolJobApplicationForm/formperma/Ux4Lun7NE-Kn4QEQBk20oXaLg3sbYHe9V3IHdUEFD68"
                        target="_blank" class="btn  ml-1 ml-lg-3 me-lg-3 w-100">Job Application Form</a>
                    <a href="https://data.odpay.in/odforms/form/MaharanaPratapPublicSchoolCitySectionRegForm202223/formperma/UUgWx_TKyXOPHxitC863YbJHrc1Eiun4VxxoDxrq2rM"
                        target="_blank" class="btn ms-1 ms-lg-3 mb-2">Click Here To Apply For MPPS City Section</a>
                    <a routerLink="/admission/entrance-result" class="btn btn-success bc mb-2 w-100 blink">Entrance Test
                        Result</a>
                    <hr>
                    <a href="tel:8059700244" target="_blank" class="btn mb-2"><i class="fas fa-phone-alt"></i>&nbsp;
                        8059700244
                        (MPPS Sector 7)</a>
                    <a href="tel:01744-259609" target="_blank" class="btn ml-1 ml-lg-3 mb-2"><i
                            class="fas fa-phone-alt"></i>&nbsp; 01744-259609 (MPPS City Section)</a>
                    <a href="https://www.youtube.com/watch?v=D7XT0R0MGO8" target="_blank"
                        class="btn  ms-1 ms-lg-3 mb-2"><i class="fab fa-youtube"></i>&nbsp;How To Check Your Entrance
                        Test Result</a>
                    <a routerLink="/admission/entrance-syllabus" class="btn  ml-1 ml-lg-3 me-lg-3 mb-2 w-100">Entrance
                        Test
                        Syllabus</a>
                </div>
            </div>
        </div>
    </div>
</div> -->